export default "__VITE_ASSET__fdc13aaa__"